module.exports = __webpack_public_path__ + "static/media/people-1.ad45b612.jpg";